<item-thumbnail class="item-thumbnail" [size]="110" [item]="item" [placeholder]="false"></item-thumbnail>
<form>
    <mat-form-field appearance="fill" [style.width.px]=180>
        <mat-label>Inventory ID</mat-label>
        <input matInput #inventoryIDField name="inventoryID" inputmode="search" autofocus scanInput="ITM"
        scanallowkeyboard (scanned)="gotoItem($event)" />
        <button mat-icon-button matSuffix type="button" *ngIf="inventoryIDField.value"
            (click)="inventoryIDField.value = ''">
            <mat-icon>cancel</mat-icon>
        </button>
    </mat-form-field>
</form>

<div *ngIf="item">
    <div>
        <mat-chip-list>
            <mat-chip [style.backgroundColor]="LifeCycleColor(item.LifeCycle)"
                [style.color]="LifeCycleContrastColor(item.LifeCycle)" class="inventory-id-chip">
                <span *ngIf="item.isMemoItem"> [MEMO]&nbsp;</span>{{item.PrimaryItem.InventoryID}}
            </mat-chip>
        </mat-chip-list>
    </div>
    <div>{{ item.Description }}</div>
    <div>{{ item.PrimaryItem.ItemClassID }}<span *ngIf="item.ItemClass"> - {{
            item.ItemClass.Description }}</span></div>
    <div>Net Price: <span *ngIf="itemNetPrice">${{itemNetPrice}} / {{item.PrimaryItem.SalesUOM}}</span></div>

    <mat-divider></mat-divider>

    <mat-tab-group>

        <mat-tab label="Specs">
            <table class="item-details" *ngIf="specs">
                <tr>
                    <td><label>Category:</label></td>
                    <td>{{specs?.PricelistCategory}} - {{specs?.PricelistType}}</td>
                </tr>
                <tr>
                    <td><label>Content:</label></td>
                    <td>{{specs?.ContentDescription}}</td>
                </tr>
                <tr>
                    <td><label>Backing:</label></td>
                    <td>{{specs?.Backing}}</td>
                </tr>
                <tr>
                    <td><label>Finish:</label></td>
                    <td>{{specs?.Finish}}</td>
                </tr>

                <tr>
                    <td><label>Width:</label></td>
                    <td>{{specs?.Width + '"'}}</td>
                </tr>
                <tr>
                    <td><label>Weight:</label></td>
                    <td>{{specs?.Weight + ' oz./linear yard'}}</td>
                </tr>
                <tr>
                    <td><label>Roll Length:</label></td>
                    <td>{{specs?.RollLength + ' yd'}}</td>
                </tr>
                <tr>
                    <td><label>Abrasion Resistance:</label></td>
                    <td>{{specs?.AbrasionResistance}}</td>
                </tr>
                <tr *ngIf="specs?.WebComment">
                    <td colspan="2">{{specs?.WebComment}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><a [href]="'https://www.mayerfabrics.com/item/' + item.InventoryID + '?utm_source=RepApp&utm_medium=ItemInq&utm_campaign=Sales'"
                            target="MayerRepAppItem"><button mat-raised-button>View on MayerFabrics.com</button></a>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td><a [href]="'https://images.mayerfabrics.com/item/' + item.InventoryID + '/specs?utm_source=RepApp&utm_medium=ItemInq&utm_campaign=Sales'"
                            target="MayerRepAppItemSpecPDF"><button mat-raised-button>View Item Spec Sheet
                                (PDF)</button></a>
                    </td>
                </tr>
            </table>
            <div *ngIf="!specs">
                <mat-spinner diameter="24" style="display:inline-block"></mat-spinner> Loading Specifications...
            </div>
        </mat-tab>

        <mat-tab label="Cleaning">
            <span style="white-space:pre-wrap;">{{specs?.CleaningComments}}</span>
        </mat-tab>

        <mat-tab label="Pricing">
            <customer-selector (onChange)="selectCustomer($event)" #customerSelector></customer-selector>
            <div *ngIf="customer">Customer Price Level: {{customer.PriceLevel}} - {{customer.PriceLevelDesc}}</div>
            <div *ngIf="itemPricing?.TariffRate">Tariff Rate: {{itemPricing?.TariffRate}}</div>

            <div *ngIf="customer && itemPricing?.LevelPrice">Standard Price: &nbsp;{{itemPricing?.LevelPrice}} / {{item.SalesUOM}}</div>
            <div *ngIf="customer && itemPricing?.LevelPrice != itemPricing?.CustomerPrice">Customer Price: {{itemPricing?.CustomerPrice}} / {{item.SalesUOM}}</div>

            <div *ngIf="levelPrices && levelPrices.length > 1" style="margin-top:1em;">
                <div>Level Pricing:</div>
                <table>
                    <tr *ngFor="let price of levelPrices">
                        <td>Level {{price.PriceCode}}</td>
                        <td>${{price.Price}}</td>
                    </tr>
                </table>
            </div>

            <ng-container *ngIf="pricing.Effective && pricing.Effective > today">
                <hr />
                <div style="font-size:150%; text-align:center;">Upcoming Price Changes</div>
                <div *ngIf="pricing.Available! > today">Available to Customers: {{pricing.Available!.format("dddd, MMM dS, yyyy")}}</div>
                <div style="margin-bottom: 1em;">Effective: {{pricing.Effective!.format("dddd, MMM dS, yyyy")}}</div>

                <div *ngIf="itemPricingChange?.TariffRate">Tariff Rate: {{itemPricingChange?.TariffRate}}</div>

                <div *ngIf="customer && itemPricingChange?.LevelPrice">Standard Price: &nbsp;{{itemPricingChange?.LevelPrice}} / {{item.SalesUOM}}</div>
                <div *ngIf="customer && itemPricingChange?.LevelPrice != itemPricingChange?.CustomerPrice">Customer Price: {{itemPricingChange?.CustomerPrice}} / {{item.SalesUOM}}</div>

                <div *ngIf="levelPricesChange && levelPricesChange.length > 1" style="margin-top:1em;">
                    <div>Level Pricing:</div>
                    <table>
                        <tr *ngFor="let price of levelPricesChange">
                            <td>Level {{price.PriceCode}}</td>
                            <td>${{price.Price}}</td>
                        </tr>
                    </table>
                </div>
            </ng-container>
        </mat-tab>

        <mat-tab label="Inventory">
            <div style="text-align:right; padding-right:1em;">~ {{totalQtyAvailable}} {{item.BaseUOM}}</div>
            <table mat-table matSort [dataSource]="inventoryData" class="inventory-table">
                <ng-container matColumnDef="LocationID">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>Location</th>
                    <td mat-cell *matCellDef="let result">{{result.LocationID}}</td>
                </ng-container>

                <ng-container matColumnDef="LotSerialNbr">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>Lot/Serial Nbr</th>
                    <td mat-cell *matCellDef="let result" [innerHTML]="result.LotSerialNbr | wrapRight:'<em>_</em>'">
                    </td>
                </ng-container>

                <ng-container matColumnDef="QtyAvailable">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>Available</th>
                    <td mat-cell *matCellDef="let result">{{result.QtyAvailable}}</td>
                </ng-container>

                <ng-container matColumnDef="menu" *ngIf="environment.mode=='wms'">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let result">
                        <buton mat-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </buton>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="printStockTag(result)">
                                <mat-icon>sell</mat-icon>Stock Tag
                            </button>
                            <button mat-menu-item (click)="inventoryAdjustment(result)">
                                <mat-icon>bolt</mat-icon>Zap
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="inventoryDisplayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: inventoryDisplayColumns;"></tr>
            </table>
        </mat-tab>

        <mat-tab label="Colors">
            <div class="pattern-color-container">
                <div *ngFor="let color of patternItemsActive" class="pattern-color" style="width:18%;">
                    <a [href]="'/item/' + color.InventoryID" style="color:#ddd;">
                        <img [src]="color.ProductImageURL()" /><br />
                        <!-- <mat-chip-list> -->
                        <!-- <mat-chip [style.backgroundColor]="LifeCycleColor(color.LifeCycle)"
                                [style.color]="LifeCycleContrastColor(color.LifeCycle)" style="width:95%;"
                                class="inventory-id-chip"> -->
                        {{color.ColorName}}<br />
                        {{(item.isMemoItem ? "M" : "") + color.PrimaryItem.InventoryID}}
                        <!-- </mat-chip> -->
                        <!-- </mat-chip-list> -->
                    </a>
                </div>
            </div>

            <div *ngIf="patternItemsDisc?.length">
                <hr />
                Discontinued Colors:<br />
                <div class="pattern-color-container">
                    <div *ngFor="let color of patternItemsDisc" class="pattern-color" style="width:18%;">
                        <a [href]="'/item/' + color.InventoryID" style="color:#ddd;">
                            <img [src]="color.ProductImageURL()" /><br />
                            <!-- <mat-chip-list> -->
                            <!-- <mat-chip [style.backgroundColor]="LifeCycleColor(color.LifeCycle)"
                                                        [style.color]="LifeCycleContrastColor(color.LifeCycle)" style="width:95%;"
                                                        class="inventory-id-chip"> -->
                            {{color.ColorName}}<br />
                            {{(item.isMemoItem ? "M" : "") + color.PrimaryItem.InventoryID}}
                            <!-- </mat-chip> -->
                            <!-- </mat-chip-list> -->
                        </a>
                    </div>
                </div>
            </div>
        </mat-tab>

    </mat-tab-group>
</div>